export { default } from "./ActivityChoiceIndicator";
